<iframe
    *ngIf="iframeSrc"
    #cloudDriveIframe
    class="cloud-drive-modal-iframe"
    [src]="iframeSrc | safe: 'resourceUrl'"
></iframe>
